import { permissionType } from '../utils/constants'
import { useUser } from '../contexts/UserContext'

export const useRewardsPermissions = () => {
  const { canAccess } = useUser()

  const canViewRewardsSetup = canAccess(permissionType.VIEW_REWARDS_SETUP, 0)
  const canViewRewardsCustomisation = canAccess(permissionType.VIEW_REWARDS_CUSTOMISATION, 0)
  const canViewRewardsAnalytics = canAccess(permissionType.VIEW_REWARDS_ANALYTICS, 0)
  const canEditSetupRewards = canAccess(permissionType.EDIT_REWARDS_SETUP, 0)
  const canEnableDisableRewards = canAccess(permissionType.ENABLE_REWARDS, 0)
  const canEditRewardsCustomisation = canAccess(permissionType.EDIT_REWARDS_CUSTOMISATION, 0)

  return {
    canViewRewardsSetup,
    canViewRewardsCustomisation,
    canViewRewardsAnalytics,
    canEditSetupRewards,
    canEnableDisableRewards,
    canEditRewardsCustomisation
  }
}
